import { render } from "./ModalVotacionMissMundo.vue?vue&type=template&id=a0948446&scoped=true"
import script from "./ModalVotacionMissMundo.vue?vue&type=script&lang=js"
export * from "./ModalVotacionMissMundo.vue?vue&type=script&lang=js"

import "./ModalVotacionMissMundo.vue?vue&type=style&index=0&id=a0948446&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0948446"]])

export default __exports__